import {required} from 'vuelidate/lib/validators'
import { mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  props: ["popupType", "selectedItem"],
  data() {
    return {
      form: {
        title: "",
        sort: "",
        checkbox_cashier_id: null,
      },
      cashiersList: [],
    };
  },

  validations: {
    form: {
      title: {
        required,
      },
      sort: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters({
      department: "catalog/department",
      cashiersForSelect: "checkbox/cashiersForSelect",
    }),
  },
  watch: {
    department(e) {
      if (e) {
        this.form.title = e.title;
        this.form.sort = e.sort;
        this.form.checkbox_cashier_id = e.checkbox_cashier_id || null;
      }
    },
    cashiersForSelect(data) {
      this.cashiersList = [];
      if (data) {
        for (let key in data) {
          this.cashiersList.push({ id: parseInt(key), title: data[key] });
        }
      }
    },
  },
  created() {
    this.getCashiersForSelect();
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    sendPriceCategory() {
      if (this.department) {
        const payload = {
          id: this.department.id,
          data: this.form,
        };
        this.$emit("changeDepartment", payload);
      } else {
        this.$emit("sendDepartment", this.form);
      }
    },
    ...mapActions({
      getCashiersForSelect: "checkbox/getCashiersForSelect",
    }),
    ...mapMutations({
      changeDepartment: "catalog/changeDepartment",
    }),
  },
  destroyed() {
    this.changeDepartment(null);
  },
};